import React, { Component } from "react";
import { 
    ContentLayout, 
    Button,
    BlogCard,
    IconSingleCard,
    Layout,
    Slider,
    SingleCard
} from "..";

export default class DefaultSection extends Component{


    renderDetail = (contentProp = {}) => {
        const{ 

            containerProps = {},
            imageProps = {},
            linkProps = {},
            slider = false,
            iconProps = {},
            cardType = "default"

        } = this.props;

        let imageProp = { ...imageProps, imageSource: contentProp.imageSource };
        let iconProp = { ...iconProps, iconName: contentProp.iconName };

        let linkProp = { ...linkProps, 
                         link: contentProp.link || linkProps.link,
                         linkText: contentProp.linkText || linkProps.linkText
                        };

        let containerProp = { ...containerProps, columns: 1 };

        switch(cardType) {
            case "icons" : return (
                                    <IconSingleCard
                                        containerProps={(slider ? containerProp : containerProps) || {}}
                                        iconProps =  {iconProp || {}}
                                        linkProps = {linkProp || {}}
                                        contentProps = {contentProp || {}}
                                    />
                                );

            case "blogs" :  return(
                                    <BlogCard
                                        containerProps={(slider ? containerProp : containerProps) || {}}
                                        imageProps =  {imageProp || {}}
                                        linkProps = {linkProp || {}}
                                        contentProps = {contentProp || {}}
                                    />
                                );
            default : return(
                                <SingleCard
                                    containerProps={(slider ? containerProp : containerProps) || {}}
                                    imageProps =  {imageProp || {}}
                                    linkProps = {linkProp || {}}
                                    contentProps = {contentProp || {}}
                                />
                            );
        }
    }

    render(){
        const {  
            containerProps = {},
            contentProps = [], 
            header = {}, 
            backgroundColor = "#000",
            sectionStyle = {}, 
            buttonProps = {} ,
            slider = false
        } = this.props;

        let noOfCards = containerProps.columns || 4 ;
        
        return(
        <Layout
            layoutStyle={{backgroundColor, ...sectionStyle }}
            extraClasses = "no-radius"
        >
            <div className="container padding-70" id = "hd">
                <ContentLayout
                    title={header.title || ""}
                    description={header.description || ""}
                    titleStyle={header.titleStyle || {}}
                    descriptionStyle={header.descriptionStyle || {}}
                    subTitle={header.subTitle || ""}
                    subTitleStyle={header.subTitleStyle || {}}
                    contentStyle={header.contentStyle || {}}
                    extraClasses={header.extraClasses || "padding-50"}
                    tag = {{ title: "h2", subTitle: "h4" , ...header.tag }}
                />
                {
                    !slider &&
                    <div className="flex wrap" style={{width: "100%"}}>
                        { contentProps.map( content => <>{ this.renderDetail(content) }</>) }
                    </div>
                }
                {
                    slider && 
                    <Slider noOfCards = {noOfCards}>
                        { contentProps.map( content => { this.renderDetail(content) }) }
                    </Slider>
                }
                { 
                    !["", undefined, null].includes(buttonProps.buttonLink)  &&
                    <Button
                        buttonText = {buttonProps.buttonText || ""} 
                        buttonStyle = {buttonProps.buttonStyle || {}}
                        extraClasses = {buttonProps.extraClasses || ""}
                        showIcon = {buttonProps.showIcon || false }
                        iconName = {buttonProps.iconName || ""}
                        iconReverse = { buttonProps.iconReverse || false } 
                        iconStyle = { buttonProps.iconStyle || {}}
                        buttonLink = {buttonProps.buttonLink || ""}
                        newTab = {buttonProps.newTab || false }
                    />
                }
            </div>
        </Layout>
        );
    }
}